import type { TrendDiscoveryQuery, TrendSource } from '../types';

export const EMPTY_SOURCE: Partial<TrendSource> = {
  name: '',
  type: 'website',
  url: '',
  category: 'mixed',
  language: 'sv',
  focusTags: [],
  notes: '',
  active: true,
  weight: 50,
  crawlMethod: 'http',
  fetchFrequency: 'weekly',
  targetedDiscovery: {
    enabled: false,
    crawlMode: 'rss_only',
    sitemapUrls: [],
    categoryPageUrls: [],
    allowPatterns: [],
    denyPatterns: [],
    maxUrlsPerRun: 6,
  },
};

export const EMPTY_DISCOVERY_QUERY: Partial<TrendDiscoveryQuery> = {
  key: '',
  label: '',
  track: 'general',
  category: 'mixed',
  language: 'sv',
  prompt: '',
  priority: 50,
  active: true,
};

export const ACTIVE_RUN_STATUSES = new Set([
  'queued',
  'running',
  'cancelling',
  'waiting_for_research',
  'research_completed',
  'analysis_completed',
  'matching_completed',
]);

export const STALLED_RUN_PROGRESS_THRESHOLD_MS = 15 * 60 * 1000;
export const STALLED_RUN_HEARTBEAT_THRESHOLD_MS = 5 * 60 * 1000;

export const STEP_LABELS: Record<string, string> = {
  queued: 'Köad',
  initializing: 'Initierar körning',
  preview_resolve_inputs: 'Laddar testunderlag',
  preview_article_analysis: 'Analyserar artikelutkast',
  preview_summarize: 'Sammanställer testresultat',
  fetch_sources: 'Hämtar källor',
  normalize_and_dedupe: 'Normaliserar och deduplicerar',
  research_synthesis: 'Sammanställer research',
  article_and_signal_analysis: 'Analyserar artiklar och trendtecken',
  verifying_signals: 'Verifierar trendtecken',
  matching_products: 'Matchar produkter',
  matching_recipes: 'Matchar recept',
  computing_opportunities: 'Beräknar möjligheter',
  clustering_stories: 'Grupperar berättelser och teman',
  generating_report: 'Genererar rapport',
  discover_open_web: 'Söker öppna webbspår',
  cancelling: 'Avbryter körning',
  matching_and_gap_analysis: 'Matchar och analyserar möjligheter',
  cancelled: 'Trendkörningen avbröts',
  completed: 'Trendkörningen är klar',
  failed: 'Trendkörningen misslyckades',
};

export const DISCOVERY_CONTRACT_FALLBACK = {
  title: 'Så discovery fungerar nu',
  summary: 'Discovery kombinerar AI-webbsök över öppna källor med riktad domäncrawl för ett litet antal kuraterade sajter. Kuraterade feeds hämtas i ordinarie körningar och manuella importer styrs redaktionellt. Det här är inte en full crawl av hela webben.',
  lanes: [
    {
      lane: 'curated_feed',
      label: 'Kuraterade källor',
      description: 'Redaktionellt valda feeds, webbplatser och partnerkällor som hämtas i ordinarie trendkörningar.',
    },
    {
      lane: 'open_web_search',
      label: 'AI-webbsök',
      description: 'AI-stödd webbresearch över öppna källor utifrån seedade discovery-frågor och deterministisk query expansion.',
    },
    {
      lane: 'targeted_domain_crawl',
      label: 'Riktad domäncrawl',
      description: 'Begränsad sitemap- eller kategorisidescrawl för ett litet antal utvalda sajter med definierade regler.',
    },
    {
      lane: 'manual_import',
      label: 'Manuell import',
      description: 'Redaktionella fynd som väljs, granskas och importeras manuellt i stället för att hämtas automatiskt.',
    },
  ],
};
